import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { catchError, map, Observable, of } from 'rxjs';
import { AdminMenuService } from '../services/admin-menu.service';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private adminMenuService: AdminMenuService,
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    if (!this.authService.isAuthenticated()) {
      return of(this.router.createUrlTree(['/login']));
    }

    const roleId = this.authService.getRoleId();
    if (!roleId) {
      return of(this.router.createUrlTree(['/login']));
    }

    const requestedPath = state.url.replace(/^[/#]+/, '').split('?')[0].split('#')[0];

    return this.adminMenuService.getByRole(roleId).pipe(
      map((menus) => {
        const normalizedPath = requestedPath.replace(/^\//, '');
        const hasAccess = menus.some((menu) => {
          const menuRoute = (menu.route || '').replace(/^\//, '');
          return menuRoute === normalizedPath;
        });

        return hasAccess
          ? true
          : this.router.createUrlTree(['/dashboard']);
      }),
      catchError(() => of(this.router.createUrlTree(['/dashboard'])))
    );
  }
}
